<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .activity-content {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(12px);

    .activity-content-group {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);
    }
  }

  .text-body3-bold {
    @include mixins.body3-bold();
    @include colors.color(black_90);
  }

  .text-caption {
    white-space: pre-wrap;
    @include mixins.caption();
    @include colors.color(black_90);
  }
</style>

<script>
  import DOMPurify from "dompurify";

  export let activity;
</script>

<div class="activity-content">
  <div class="activity-content-group">
    {#if activity.to}
      <span class="text-caption"><b>To:</b> {activity.to}</span>
    {/if}
    {#if activity.subject}
      <span class="text-caption"><b>Subject:</b> {activity.subject}</span>
    {/if}
    {#if activity.title}
      <span class="text-caption"><b>Title:</b> {activity.title}</span>
    {/if}
  </div>
  {#if activity.content}
    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
    <p class="text-caption">{@html DOMPurify.sanitize(activity.content)}</p>
  {/if}
</div>
